import { EBlotterTab, ERightSideBarEnum, ESettingsOption } from '../enums';
import { IAlkListMenuOption } from '@alk/core';
import { IColumnState, IFilterModel } from './grid-layout.interface';
import { ILimit, IStateObject, IValueWithReadonlyState } from '.';
import { IPadConfig } from './pad.interface';
import { ITradingQuantities } from './trading-quantities.interface';
import { SpotType } from '@fnx/fx-pad';

export type ISettings = {
    selectedClientId: number | undefined,
    pads: Array<IPadConfig>,
    selectedRightBarIdx: ERightSideBarEnum,
    tradingLayoutHeight: number | undefined,
    readNotifications: Array<string>
    clickMode: ClickMode,
    tradingEnabled: boolean,
    spotColumnState?: Array<IColumnState>,
    forwardColumnState?: Array<IColumnState>,
    pendingColumnState?: Array<IColumnState>,
    kondorColumnState?: Array<IColumnState>,
    positionColumnState?: Array<IColumnState>,
    spotFilterModel?: IFilterModel,
    forwardFilterModel?: IFilterModel,
    pendingFilterModel?: IFilterModel,
    isColumnFilteringEnabled: boolean,
    blotterSearchFilter: string,
    blotterSelectedTab: EBlotterTab,
    selectedNotificationFilter: Array<IAlkListMenuOption>;
    selectedSetting: ESettingsOption;
    tradingQuantities: ITradingQuantities,
    selectedLimit?: ILimit,
};

export const CLICK_MODE_ARRAY = [ 'confirm', 'click' ] as const;
export type ClickMode = typeof CLICK_MODE_ARRAY[number];
export const RAW_CLICK_MODE_ARRAY = [ ...CLICK_MODE_ARRAY, 'free' ] as const;
export type RawClickMode = typeof RAW_CLICK_MODE_ARRAY[number];

export interface IRawTradingSettings {
    clickMode?: RawClickMode;
    tradingEnabled?: boolean;
    availableOrderTypes?: Array<SpotType>,
    hasInHouseAttached?: boolean,
}

export type AllChangable<T> = {
    [K in keyof T]: IValueWithReadonlyState<T[K]>;
};

export type ITradingStateSettings = Pick<IStateObject, 'clickMode' | 'tradingEnabled'>;

export type IResultTradingSettings = AllChangable<ITradingStateSettings> & Omit<IRawTradingSettings, 'clickMode' | 'tradingEnabled'>;
